import { useState } from "react";
import { toast } from "sonner";
import { LOGO_URL } from "@/lib/assets";
import { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username.trim(), password);
      toast.success("Accesso effettuato");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center px-6 fade-in">
      <div className="w-full max-w-sm">
        <div className="flex justify-center mb-8">
          <img src={LOGO_URL} alt="SPLENDI" className="h-24 w-auto object-contain" />
        </div>
        <div className="bg-white rounded-2xl border border-slate-200 shadow-sm p-6">
          <h1 className="font-head text-2xl font-bold text-slate-900 mb-1">Accedi</h1>
          <p className="text-slate-500 text-sm mb-6">Inserisci username e password</p>
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm font-semibold text-slate-600 mb-1.5 block">Username</label>
              <input
                data-testid="login-username"
                type="text"
                autoCapitalize="none"
                autoComplete="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="w-full h-14 rounded-xl border border-slate-200 px-4 text-lg outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
                placeholder="es. mario"
              />
            </div>
            <div>
              <label className="text-sm font-semibold text-slate-600 mb-1.5 block">Password</label>
              <input
                data-testid="login-password"
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full h-14 rounded-xl border border-slate-200 px-4 text-lg outline-none focus:border-primary focus:ring-2 focus:ring-primary/20"
                placeholder="••••••••"
              />
            </div>
            {error && (
              <p data-testid="login-error" className="text-sm text-destructive font-medium">
                {error}
              </p>
            )}
            <button
              data-testid="login-submit"
              type="submit"
              disabled={loading}
              className="w-full h-14 rounded-xl bg-primary text-primary-foreground text-lg font-bold flex items-center justify-center gap-2 active:scale-[0.98] transition-transform disabled:opacity-60"
            >
              {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Entra"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
